import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "cdnsa-daily-trend",
  module: widgetModule,
  catalog: {
    description: "Daily distinct observed detections in UTC.",
    domain: "cdnsa",
    visual: "Bar chart",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
